import React from "react";
import { useSelector } from "react-redux";
import { usePrivilege } from "../../helpers";
// import SwitchPracticeModal from "./SwitchPracticeModal";

const MyProfileSidebar = () => {
  const privilege = usePrivilege();
  const profileInfo = useSelector((store: any) => store.profileInfo);

  return (
    <>
      <div className="h-100">

        <div className="text-center myprofile-title">My Profile</div>
        <div className="col-12 offsider-pos-center h-100">
          <span className="text-gray">
            <i className="far fa-user fa-3x" aria-hidden="true"></i>
          </span>
          <h4 className="m-0 p-top-1 display-name">{profileInfo.displayName}</h4>
          <h5 className="m-0 p-top-1 role-name">{profileInfo.roleName}</h5>
          <h5 className="m-0 p-top-1 d-flex align-items-center justify-content-center practice-name">
          </h5>
          {profileInfo.email &&
            <h5 className="m-0 d-flex align-items-center justify-content-center email">
              <span className="text-gray m-right-1">
                <i className="far fa-envelope" aria-hidden="true"></i>
              </span>
              {profileInfo.email}
              <span className="m-left-1">
                <i className="fas fa-check-circle verified"></i>
              </span>
            </h5>
          }
        </div >
      </div >
    </>
  );
};

export default MyProfileSidebar;
